import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { LfwRouterService } from '../../route/lfw-router.service';
import { InfoService } from '../../shared/services/info.service';
import { OfflineFormsClient, OfflineOrders } from '../offline-orders/offline-forms.client';
import { OfflineOrderViewComponent } from '../offline-orders/offline-order-view/offline-order-view.component';

@Component({
  selector: 'lfw-temporary-offline-orders',
  templateUrl: './temporary-offline-orders.component.html',
  styleUrls: ['./temporary-offline-orders.component.css'],
  imports: [OfflineOrderViewComponent]
})
export class TemporaryOfflineOrdersComponent {
  private readonly offlineFormsClient = inject(OfflineFormsClient);
  private readonly routerService = inject(LfwRouterService);
  private readonly infoService = inject(InfoService);

  readonly temporaryOfflineOrders$: Observable<OfflineOrders> = this.offlineFormsClient.onlyTemporaryOfflineOrders$;

  private readonly hasTemporaryOfflineOrdersSignal = toSignal(this.offlineFormsClient.onlyTemporaryOfflineOrders$);

  constructor() {
    effect(() => {
      const hasTemporaryOfflineOrders = this.hasTemporaryOfflineOrdersSignal();
      const isLoaded = this.offlineFormsClient.isLoaded();

      if (!isLoaded || hasTemporaryOfflineOrders === undefined) {
        return;
      }

      const count = Object.keys(hasTemporaryOfflineOrders).length;
      if (count === 0) {
        this.routerService.navigateToOrdersRoot();
        return;
      }

      this.infoService.setLoadedItems(count);
    });
  }
}
